import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=78758fd4&scoped=true&"
import script from "./Marketing.vue?vue&type=script&lang=js&"
export * from "./Marketing.vue?vue&type=script&lang=js&"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=78758fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78758fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78758fd4')) {
      api.createRecord('78758fd4', component.options)
    } else {
      api.reload('78758fd4', component.options)
    }
    module.hot.accept("./Marketing.vue?vue&type=template&id=78758fd4&scoped=true&", function () {
      api.rerender('78758fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/Marketing.vue"
export default component.exports